export function insertAt(array, index, ...elements) {
    array.splice(index, 0, ...elements);
}

export const chunkArray = (array, size) => {
    if (size <= 0) {
        throw new Error('Chunk size must be a positive number');
    }

    return Array.from({ length: Math.ceil(array.length / size) }, (_, i) => array.slice(i * size, i * size + size));
};

/**
 * @param {any[]} items
 * @param {number} chunkSize
 * @param {(item: any) => Promise<any>} handler
 * @returns {Promise<void>}
 */
export async function processInChunks(items, chunkSize, handler) {
    const chunks = chunkArray(items, chunkSize);
    for (const chunk of chunks) {
        await Promise.all(chunk.map(handler));
    }
}
